import { styled } from 'parkdepot-shared/theme'

export const LinkContainer = styled<'a', { $disabled: boolean }>('a', ({ $theme, $disabled }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 700,
    color: '#5046E8',
    textDecoration: 'underline #5046E8',
    opacity: $disabled ? 0.5 : 1,
    cursor: $disabled ? 'not-allowed' : 'pointer'
}))
